<template>
  <div class="add-update-form app__specified-form">
    <input-field
      v-model="form.title"
      :label="i18n.sale_update_news()"
    />
    <textarea-field v-model="form.message"
                    v-validate="'required'"
                    :label="i18n.sale_updates_textarea_label()"
                    :placeholder="i18n.sale_updates_textarea_placeholder()"
                    class="step__input-field"
                    :maxlength="250"
    />
    <div class="btn-wrap space-between">
      <md-button class="btn md-primary"
                 :disabled="isPending" @click="createUpdate"
      >{{ i18n.sale_updates_add_note_bt() }}</md-button>
      <md-button class="btn md-primary" @click="$emit(events.closeEvent)">{{i18n.lbl_cancel()}}</md-button>
    </div>
    <div class="text_small text_description text_margin">{{ i18n.sale_updates_add_note_text() }}</div>
  </div>
</template>

<script>
  import InputField from '@com/fields/InputField'
  import FormMixin from '@com/mixins/form.mixin'
  import { i18n } from '@js/i18n'
  import moment from 'moment'
  import { commonEvents } from '@js/events/common_events'
  import { confirmAction } from '@js/modals/confirmation_message'
  import { blobTypes, blobFilters } from '@const'
  import { usersService } from '@api/users.service'
  export default {
    name: 'add-update-form',

    components: {
      InputField
    },

    mixins: [FormMixin],
    props: ['sale'],

    data: _ => ({
      form: {
        title: '',
        message: ''
      },
      events: {
        closeEvent: commonEvents.closeEvent
      },
      i18n
    }),

    methods: {
      async createUpdate () {
        if (!await this.isValid()) return
        const confirmed = await confirmAction({ message: i18n.sale_upd_tab_warning() })
        if (!confirmed) return
        this.disable()
        try {
          const date = moment() // .format('MMMM Do')
          await usersService.blobsOf(this.sale.owner).create(
            blobTypes.fundUpdate.str,
            {
              ...this.form,
              date
            },
            { [blobFilters.fundID]: this.sale.id }
          )
          this.$emit(commonEvents.timelineAddFinished)
          this.$emit(commonEvents.closeEvent)
        } catch (error) {
          console.error(error)
          error.showBanner(i18n.unexpected_error)
        }
        this.enable()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/UpdatesTab.Timeline.AddForm.vue